import type { UnknownAction } from '@reduxjs/toolkit';

export class ErrorFromRedux extends Error {
  constructor(message: string, stack: string | undefined, action: UnknownAction) {
    super(message, { cause: action });
    this.stack = stack;
  }
}
